<div class="control__header__label" [ngClass]="fontColorClass">{{ earlyOrLateText | uppercase }}</div>
